module.exports = __webpack_public_path__ + "img/ch8pic4.92358ac0.png";